import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import TrackTraceForm from "~/components/TrackTrace/TrackTraceForm";
import cleanup from "~/helpers/cleanup";

export interface IState {
  orderNumber: string;
  postalCode: string;
}

class FormContainer extends React.Component<RouteComponentProps<{}>, IState> {
  public readonly state = {
    orderNumber: "",
    postalCode: ""
  };

  public render() {
    const { orderNumber, postalCode } = this.state;

    return (
      <TrackTraceForm
        orderNumber={orderNumber}
        postalCode={postalCode}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
      />
    );
  }

  private handleChange = (state: Partial<IState>) =>
    this.setState(prevState => ({ ...prevState, ...state }));

  private handleSubmit = () => {
    const { orderNumber, postalCode } = this.state;

    this.props.history.push(
      `/track-trace/${cleanup(postalCode)}/${cleanup(orderNumber)}`
    );
  };
}

export default withRouter(FormContainer);



// WEBPACK FOOTER //
// ./src/containers/TrackTrace/FormContainer.tsx